/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { defaultUserImg, FilterIcon } from '../../helper/imagepath'
import MapIcon from '../../assets/img/svg/map-icon.svg'
import { getAllCleaner } from '../../redux/slices/cleanersSlice'
import { useDispatch, useSelector } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { appendImageURL, convertTimestampToDate, formatCustomTrim, getDayStartAndEndTimestamps, getTimeStamp } from '../../helper/function'
import { Spinner } from 'react-bootstrap'
import CleanersFilter from './cleanersFilter'
import { getAllRegion } from '../../redux/slices/regionSlice'
import RatingDisplay from '../../component/rating'
import Pagination from '../../component/common/pagination'
import { errorToast } from '../../util/Toast/toast'

const Cleaners = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { changeLoader } = useContext(SpinnerContext)
  const { allCleaner } = useSelector(({ cleaners }) => cleaners)
  const [isRefresh, setIsRefresh] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [filterData, setFilterData] = useState({})
  const [currentPage, setCurrentPage] = useState(allCleaner?.currentPage || 1)
  // eslint-disable-next-line no-unused-vars
  const [itemsPerPage, setItemsPerPage] = useState(6)
  const [activeTab, setActiveTab] = useState('current-cleaners')
  const [loading, setLoading] = useState(false)

  const formRef = useRef()

  const handleReset = () => {
    if (formRef.current) {
      formRef.current.resetForm() // Call the reset function from child
    }
  }

  useEffect(() => {
    // changeLoader(true)
    dispatch(getAllRegion())
      .then(() => {
        changeLoader(false)
      })
      .catch(() => {
        changeLoader(false)
      })
  }, [])

  // Handle tab change
  const handleTabChange = (tabName) => {
    setActiveTab(tabName)
    setCurrentPage(1) // Reset pagination to first page when tab changes
    // setFilterData({})
    // handleReset()
  }

  // Handle page change, adjusting for 1-based index
  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected + 1) // Add 1 to the index to start from 1
  }

  const handlePagination = async (page, pageSize) => {
    setCurrentPage(page)
    setItemsPerPage(pageSize)
  }

  useEffect(() => {
    // Determine contract status and finished contract flag based on the active tab
    let contract_status = null
    let is_finished_contract = null

    if (activeTab === 'current-cleaners') {
      contract_status = 'accepted'
    } else if (activeTab === 'new-applies') {
      contract_status = 'pending'
    } else if (activeTab === 'finished-contracts') {
      contract_status = 'completed'
    }

    const { endOfDayTimestamp } = getDayStartAndEndTimestamps(getTimeStamp(filterData?.created_end))

    // Prepare the parameters for the API call
    const params = {
      page: currentPage,
      limit: itemsPerPage || 10,
      sort_column: 'created_at',
      sort_order: 'DESC',
      contract_status,
      region_id: filterData?.region,
      city_id: filterData?.city_id,
      created_start: filterData?.created_start && getTimeStamp(filterData?.created_start),
      created_end: filterData?.created_end && endOfDayTimestamp
    }

    // Add filter if name exists in filterData
    if (filterData?.name) {
      params.name = formatCustomTrim(filterData.name)
    }

    // Start loading and dispatch API call
    changeLoader(true)
    setLoading(true)
    dispatch(getAllCleaner(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
          setLoading(false)
          setLoading(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
          setLoading(false)
          setLoading(false)
        }
      })
      .catch((error) => {
        console.error('API Error:', error)
        changeLoader(false)
        setLoading(false)
      })
  }, [itemsPerPage, currentPage, isRefresh, filterData, activeTab])

  return (
    <>
      <div className="page-wrapper customers">
        <div className="content">
          <div className="title_header">
            <h5 className="sec_title_text d-flex align-items-center">
              {/* <i className="fa fa-angle-left fs-5 me-2" aria-hidden="true"></i> */}
              Cleaners
            </h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                    <span className="me-2">
                      <img src={FilterIcon} alt="filter" />
                    </span>
                    Filter{' '}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Tabs Start */}
          <div className="tabs_flex_div">
            <div className="reviews_topbar">
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item review_btn" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'current-cleaners' ? 'active' : ''}`}
                    onClick={() => handleTabChange('current-cleaners')}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === 'current-cleaners'}
                  >
                    Current Cleaners
                  </button>
                </li>
                <li className="nav-item review_btn" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'new-applies' ? 'active' : ''}`}
                    onClick={() => handleTabChange('new-applies')}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === 'new-applies'}
                  >
                    New Applies
                  </button>
                </li>
                <li className="nav-item review_btn" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'finished-contracts' ? 'active' : ''}`}
                    onClick={() => handleTabChange('finished-contracts')}
                    type="button"
                    role="tab"
                    aria-selected={activeTab === 'finished-contracts'}
                  >
                    Finished Contracts
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* Tabs content */}
          <div className="tab-content">
            <div className="tab-pane fade show active" role="tabpanel">
              {!loading ? (
                <div className="common_card_div">
                  <div className="row col_space_div">
                    {allCleaner?.totalRecords > 0 ? (
                      allCleaner?.cleaners?.map((cleaner, index) => (
                        <div className="col-md-6" key={index}>
                          <div className="user_details_div" onClick={() => navigate(`/cleaners/cleaners-info/${cleaner.cleaners_id}`)}>
                            <div className="user_left_div">
                              <img
                                className="img-fluid w-100"
                                src={cleaner?.profile_image ? appendImageURL(cleaner?.profile_image) : defaultUserImg}
                                alt="Image"
                              />
                            </div>
                            <div className="user_right_div">
                              <div className="user_title_div d-flex justify-content-between gap-2 mb-2">
                                <h5 className="black_color fw-500 fs-20">
                                  {cleaner.first_name ? `${cleaner.first_name} ${cleaner.last_name}` : '-'}
                                </h5>
                                <div className="review_star">
                                  <RatingDisplay selectedValue={cleaner?.rating} />
                                </div>
                              </div>
                              <div className="user_switch_div d-flex justify-content-between align-items-center gap-2 mb-2">
                                <div>
                                  <label title="" className="form-check-label dark_gray_color">
                                    {cleaner.total_cleaning ? `Cleanings Done: ${cleaner.total_cleaning}` : 'Cleanings Done: 0'}
                                  </label>
                                </div>
                                <p className="dark_gray_color fw-500 fs-16">
                                  {cleaner.created_at ? convertTimestampToDate(cleaner.created_at) : '-'}
                                </p>
                              </div>
                              <div className="user_details_box mb-0">
                                <div className="icon_box_div">
                                  <img className="img-fluid" src={MapIcon} alt="Image" />
                                </div>
                                <h6 className="gray_color">{cleaner.city_name ? cleaner.city_name : 'None'}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p style={{ textAlign: 'center' }}>{`No cleaners found.`}</p>
                    )}
                  </div>

                  {/* Pagination */}
                  {allCleaner?.cleaners?.length > 0 && (
                    <Pagination
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                      totalPages={allCleaner?.totalPage || 0}
                      itemsPerPage={itemsPerPage}
                    />
                  )}
                </div>
              ) : (
                !loading && <p style={{ textAlign: 'center' }}>No Data Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <CleanersFilter
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        handlePagination={handlePagination}
        setFilterData={setFilterData}
        ref={formRef}
      />
    </>
  )
}

export default Cleaners
